import { EventStats } from './EventStats';

export default EventStats;
